import axios from "axios"
import type {
  IVolunteerRegistrationRequest,
  IVolunteerRegistrationResponse,
} from "./volunteer.model"

export const volunteerRegistration = async (
  url: string,
  data: IVolunteerRegistrationRequest,
): Promise<IVolunteerRegistrationResponse> => {
  const payload: IVolunteerRegistrationRequest = data
  const response = await axios.post<IVolunteerRegistrationResponse>(url, payload)

  return response.data
}
